import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
export const BoxRelative = t0 => {
  const $ = _c(5);
  const {
    children,
    sx
  } = t0;
  let t1;
  if ($[0] !== sx) {
    t1 = {
      position: "relative",
      ...sx
    };
    $[0] = sx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <Box sx={t1}>{children}</Box>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};